import { getActiveSocialLinks } from '@/lib/social-media';

interface SocialMediaLinksProps {
  variant?: 'footer' | 'hero' | 'inline';
  size?: 'sm' | 'md' | 'lg';
  showLabels?: boolean;
  className?: string;
}

const SocialMediaLinks = ({ 
  variant = 'inline', 
  size = 'md',
  showLabels = false,
  className = '' 
}: SocialMediaLinksProps) => {
  const socialLinks = getActiveSocialLinks();
  
  const sizeClasses = {
    sm: 'w-8 h-8',
    md: 'w-10 h-10', 
    lg: 'w-12 h-12'
  };
  
  const iconSizes = {
    sm: 'h-4 w-4',
    md: 'h-5 w-5',
    lg: 'h-6 w-6'
  };
  
  const baseClasses = `
    inline-flex items-center justify-center rounded-full 
    transition-all duration-300 hover:scale-110 hover:shadow-lg
    bg-muted/10 hover:bg-muted/20 border border-border/50
    ${sizeClasses[size]}
  `;

  return (
    <div className={`flex items-center space-x-3 ${className}`}>
      {showLabels && (
        <span className="text-muted-foreground text-sm">Follow us:</span>
      )}
      <div className="flex space-x-3">
        {socialLinks.map((social) => {
          const Icon = social.icon;
          return (
            <a
              key={social.name}
              href={social.url}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={social.ariaLabel}
              className={baseClasses}
              title={`Visit our ${social.name} page`}
            >
              <Icon 
                className="text-muted-foreground hover:text-foreground transition-colors"
                size={size === 'sm' ? 16 : size === 'md' ? 20 : 24}
              />
            </a>
          );
        })}
      </div>
    </div>
  );
};

export default SocialMediaLinks;